import { MemreButton, MemreFlexBox, MemreModal } from 'components/core';
import { useState } from 'react';
import ImageUploadModal from './ImageUploadModal';

interface ImageButtonProps {
  imageUrl?: string;
  onAddImage: (url: string, id: string) => void;
  onDeleteImage: () => void;
  buttonSize?: 'small' | 'medium' | 'large';
  imageHeight?: number;
}

export default function ImageButton({
  imageUrl,
  onAddImage,
  onDeleteImage,
  buttonSize = 'small',
  imageHeight = 56
}: ImageButtonProps) {
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const handleButtonClick = () => {
    setModalContent(
      <ImageUploadModal 
        addImageMethod={(url, id) => {
          onAddImage(url, id);
          setModalContent(null);
        }} 
        close={() => setModalContent(null)} 
      />
    );
  };

  return (
    <>
      {imageUrl && (
        <MemreFlexBox
          direction="column"
          sx={{ position: 'relative', height: `${imageHeight}px` }}
          align="center"
          justify="center"
        >
          <div
            style={{
              aspectRatio: '1/1',
              height: '100%',
              backgroundImage: `url(${imageUrl})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              borderRadius: '4px',
            }}
          />
          <MemreButton
            variant="icon"
            iconName="trash"
            onClick={onDeleteImage}
            sx={{ position: 'absolute', backgroundColor: 'white' }}
          />
        </MemreFlexBox>
      )}
      {!imageUrl && (
        <MemreButton
          variant="outlined"
          text="Add Image"
          size={buttonSize}
          iconName="image"
          onClick={handleButtonClick}
        />
      )}
      <MemreModal>{modalContent}</MemreModal>
    </>
  );
}